import { TableColumnId } from '@manage-ceg/components/manage-ceg-table-container/manage-ceg-table-container.enum';
import { BudgetStatus } from './budget-status.type';

export interface Budget { // TODO: later rename properties to follow ts naming conventions, not Python ones!!!
  id: number;
  name: string;
  type: string;
  company: number;
  owner: number;
  budget_from: string;
  budget_to: string;
  mailing: boolean;
  status: BudgetStatus;
  suppress_timeframe_allocations?: boolean;
  have_locked_timeframe: boolean;
  fixed_date?: string;
  amount: number;
  crd: string;
  upd: string;
  new_campaigns_programs_structure?: boolean;
  is_forecast_enabled?: boolean;
  anchor_field?: TableColumnId.Budget | TableColumnId.Forecast; // '1' - Budget, '2' - Forecast
}

export enum BudgetTimeframesType {
  Year = 'Year',
  Month = 'Month',
  Quarter = 'Quarter'
}

export interface BudgetCABFormula {
  crd?: string;
  upd?: string;
  id : number;
  budget: number | null;
  name: string;
  display_order: number;
  manage_page_fields: number;
}

